import FiberManualRecord from "@mui/icons-material/FiberManualRecord";
import { IconButton, IconButtonProps, styled, SvgIconProps } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { MUIStyledCommonProps } from "@mui/system";
import { ComponentProps, FC } from "react";

/** `@emotion/styled` is only a transitive dependency, so its `StyledComponent` type cannot be
 * named in the emitted declarations. Every export below needs an explicit annotation (TS2883). */
type StyledDiv = FC<ComponentProps<"div"> & MUIStyledCommonProps<Theme>>;

export const StyledRoot: StyledDiv = styled("div")({
	position: "relative",
	overflow: "hidden",
});

export const StyledItem: StyledDiv = styled("div")({
	position: "absolute",
	height: "100%",
	width: "100%",
	//    flexGrow: 1
});

export const StyledItemWrapper: StyledDiv = styled("div")({
	position: "relative",
	width: "100%",
	height: "100%",
});

export const StyledIndicators: StyledDiv = styled("div")({
	width: "100%",
	marginTop: "10px",
	textAlign: "center",
});

export const StyledFiberManualRecordIcon: FC<SvgIconProps> = styled(FiberManualRecord)({
	fontSize: "15px",
});

export const StyledIndicatorIconButton: FC<IconButtonProps & { $active: boolean }> = styled(IconButton, {
	shouldForwardProp: (propName: string) => !propName.startsWith("$"),
})<{ $active: boolean }>(({ $active }) => ({
	cursor: "pointer",
	transition: "200ms",
	padding: 0,
	color: $active ? "#494949" : "#afafaf",
	"&:hover": {
		color: $active ? "#494949" : "#1f1f1f",
	},
	"&:active": {
		color: $active ? "#494949" : "#1f1f1f",
	},
}));

export const StyledIconButton: FC<IconButtonProps & { $alwaysVisible: boolean; $fullHeightHover: boolean }> = styled(
	IconButton,
	{
		shouldForwardProp: (propName: string) => !propName.startsWith("$"),
	},
)<{ $alwaysVisible: boolean; $fullHeightHover: boolean }>(({ $alwaysVisible }) => ({
	margin: "0 10px",
	position: "relative",
	backgroundColor: "#494949",
	top: "calc(50% - 20px) !important",
	color: "white",
	fontSize: "30px",
	transition: "200ms",
	cursor: "pointer",
	opacity: $alwaysVisible ? "1" : "0",
	"&:hover": {
		opacity: "0.6 !important",
	},
}));

export const StyledButtonWrapper: FC<
	ComponentProps<"div"> & MUIStyledCommonProps<Theme> & { $next: boolean; $prev: boolean; $fullHeightHover: boolean }
> = styled("div", {
	shouldForwardProp: (propName: string) => !propName.startsWith("$"),
})<{ $next: boolean; $prev: boolean; $fullHeightHover: boolean }>(({ $next, $prev, $fullHeightHover }) => ({
	position: "absolute",
	height: "100px",
	backgroundColor: "transparent",
	zIndex: 1,
	top: "calc(50% - 70px)",
	"&:hover": {
		"& button": {
			backgroundColor: "black",
			filter: "brightness(120%)",
			opacity: "0.4",
		},
	},
	...($fullHeightHover
		? {
				height: "100%", // This is 100% - indicator height - indicator margin
				top: "0",
			}
		: undefined),
	...($next ? { right: 0 } : undefined),
	...($prev ? { left: 0 } : undefined),
}));
